import { __decorate } from "tslib";
import { _GraphQueryableInstance, _GraphQueryableCollection, graphInvokableFactory, } from "../graphqueryable.js";
import { defaultPath, getById } from "../decorators.js";
/**
 * Represents a insights entity
 */
let _Insights = class _Insights extends _GraphQueryableInstance {
    get trending() {
        return TrendingInsights(this);
    }
    get used() {
        return UsedInsights(this);
    }
    get shared() {
        return SharedInsights(this);
    }
};
_Insights = __decorate([
    defaultPath("insights")
], _Insights);
export { _Insights };
export const Insights = graphInvokableFactory(_Insights);
/**
 * Describes a Trending Insight instance
 */
export class _TrendingInsight extends _GraphQueryableInstance {
    get resource() {
        return Resource(this);
    }
}
export const TrendingInsight = graphInvokableFactory(_TrendingInsight);
/**
 * Describes a collection of Trending Insight objects
 *
 */
let _TrendingInsights = class _TrendingInsights extends _GraphQueryableCollection {
};
_TrendingInsights = __decorate([
    defaultPath("trending"),
    getById(TrendingInsight)
], _TrendingInsights);
export { _TrendingInsights };
export const TrendingInsights = graphInvokableFactory(_TrendingInsights);
/**
 * Describes a Used Insight instance
 */
export class _UsedInsight extends _GraphQueryableInstance {
    get resource() {
        return Resource(this);
    }
}
export const UsedInsight = graphInvokableFactory(_UsedInsight);
/**
 * Describes a collection of Used Insight objects
 *
 */
let _UsedInsights = class _UsedInsights extends _GraphQueryableCollection {
};
_UsedInsights = __decorate([
    defaultPath("used"),
    getById(UsedInsight)
], _UsedInsights);
export { _UsedInsights };
export const UsedInsights = graphInvokableFactory(_UsedInsights);
/**
 * Describes a Shared Insight instance
 */
export class _SharedInsight extends _GraphQueryableInstance {
    get resource() {
        return Resource(this);
    }
}
export const SharedInsight = graphInvokableFactory(_SharedInsight);
/**
 * Describes a collection of Shared Insight objects
 *
 */
let _SharedInsights = class _SharedInsights extends _GraphQueryableCollection {
};
_SharedInsights = __decorate([
    defaultPath("shared"),
    getById(SharedInsight)
], _SharedInsights);
export { _SharedInsights };
export const SharedInsights = graphInvokableFactory(_SharedInsights);
/**
 * Describes a Resource Entity instance
 */
let _Resource = class _Resource extends _GraphQueryableInstance {
};
_Resource = __decorate([
    defaultPath("resource")
], _Resource);
export { _Resource };
export const Resource = graphInvokableFactory(_Resource);
//# sourceMappingURL=types.js.map